import { Slider } from '@mui/material'
import clsx from 'clsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SUB_CLEAN_MODES } from 'utils/constants'
import { ICleaningModeConfig } from 'utils/interfaces'

import style from './AutoCleaningParams.module.css'

const AutoCleaningParams = ({
  config,
  onChange,
}: {
  config?: ICleaningModeConfig
  onChange: (config: ICleaningModeConfig) => void
}) => {
  const { t } = useTranslation()
  const [sliderValue, setSliderValue] = useState(config && 'autoMode' in config ? config.autoMode : 1)

  const handleSliderChange = (event: Event, value: number | number[]) => {
    const newValue = Number(value)
    setSliderValue(newValue)
    onChange({ mode: SUB_CLEAN_MODES.AUTO, autoMode: newValue })
  }

  const valueLabelFormat = (value: number) => {
    switch (value) {
      case 1:
        return t('zone_details.cleaning_degree_fastest')
      case 4:
        return t('zone_details.cleaning_degree_cleanest')
      default:
        return `${value}`
    }
  }

  return (
    <div className={style.root}>
      <div className={clsx('text-14-400', style.subtitle)}>{t('zone_details.cleaning_degree')}</div>
      <div className={style.content}>
        <Slider
          aria-label={t('zone_details.cleaning_degree')}
          step={1}
          min={1}
          max={4}
          marks={[1, 2, 3, 4].map(value => ({
            value,
            label: valueLabelFormat(value),
          }))}
          value={sliderValue}
          onChange={handleSliderChange}
        />
      </div>
    </div>
  )
}

export default AutoCleaningParams
